import { useState, useEffect } from 'react';
import { Text } from '@chakra-ui/react'
import { DataTableHeader } from './DataTableHeader'
import { DataTableFooter } from './DataTableFooter'
import { ThemedFlex } from '../../theme/ThemedFlex'
import { SATOSHI_QUOTES } from '../../utils/satoshiQuotes'

export const QuoteTile = ({ title, subtitle, icon, link, linkLabel }) => {
    const quotes = SATOSHI_QUOTES;

    const [randomQuote, setRandomQuote] = useState(
        quotes[Math.floor(Math.random() * quotes.length)]
    );

    useEffect(() => {
        const changeQuote = () => {
            const newQuote = quotes[Math.floor(Math.random() * quotes.length)];
            setRandomQuote(newQuote);
        };

        const timer = setTimeout(changeQuote, 180000);

        return () => clearTimeout(timer);
    }, [randomQuote, quotes]);

    return (
        <ThemedFlex
            direction="column"
            mb="12px"
            py="18px"
            pb="24px"
            px="20px"
            flex={1}
            borderRadius={3}
        >
            <DataTableHeader title={title} subtitle={subtitle} icon={icon} />
            <Text fontStyle='italic' fontSize='18px' lineHeight='22px' mt={4}>{randomQuote.quote}</Text>
            <DataTableFooter link={link} linkLabel={linkLabel} />
        </ThemedFlex>
    )
}